// import n3d from "./n3d.module.js";

export function worldToScreen(obj, camera, container) {
    let v = new v3d.Vector3();
    v.setFromMatrixPosition(obj.matrixWorld).project(camera);
    const hw = container.offsetWidth / 2;
    const hh = container.offsetHeight / 2;
    return {
        x: v.x * hw + hw,
        y: -v.y * hh + hh
    };
}
/**
 * 基类
 */
export default class N3dTools extends v3d.EventDispatcher {
    constructor(container, initOptions) {
        super();
        this.container = container;
        this.initOptions = initOptions;
        this._pGlob = {};
        this._pGlob.objCache = {};
        this._pGlob.vec3Tmp = new v3d.Vector3();
        this._pGlob.vec3Tmp2 = new v3d.Vector3();
        this._pGlob.animMixerCallbacks = [];
        // this._pGlob.screenCoords = new v3d.Vector2();
        this._pGlob.eventListeners = [];
        this.mouse = new v3d.Vector2();
        this.raycaster = new v3d.Raycaster();
    }

    execAnims = (anims, play) => {
        for (let i = 0; i < anims.length; i++) {
            let animName = anims[i];
            let action = v3d.SceneUtils.getAnimationActionByName(
                this.app,
                animName
            );
            if (action) {
                // console.log('playRayAnim', animName, play, action.isRunning());
                if (play) {
                    action.reset().play();
                } else {
                    action.reset().stop();
                }
            } else {
                console.warn("no anim", animName);
            }
        }
    };

    getPositionByName = name => {
        const obj = this.getObjectByName(name);
        if (!obj) {
            return { x: 0, y: 0 };
        }
        const position = worldToScreen(
            obj,
            this.app.camera,
            this.app.container
        );
        console.log(position);
        return position;
    };

    _dispose = () => {
        if (!this.app) return;
        try {
            this.unBindEventListener(this.app);
            this.app.dispose();
            this.app = null;
        } catch (e) {
            console.log(e);
        }
    };

    createApp({ container, sceneURL, callback }) {
        if (!sceneURL) {
            console.log("No scene URL specified");
            return;
        }

        // some puzzles can benefit from cache
        v3d.Cache.enabled = true;

        let PL = null,
            PE = null;
        // if (v3d.AppUtils.isXML(logicURL)) {
        //   const PUZZLES_DIR = '/model/puzzles/';
        //   const logicURLJS = logicURL.match(/(.*)\.xml$/)[1] + '.js';
        //   PL = await new v3d.PuzzlesLoader().loadEditorWithLogic(PUZZLES_DIR, logicURLJS);
        //   PE = v3d.PE;
        // } else if (v3d.AppUtils.isJS(logicURL)) {
        //   PL = await new v3d.PuzzlesLoader().loadLogic(logicURL);
        // }

        let initOptions = { useFullscreen: false, useBkgTransp: true, ...this.initOptions};
        // if (PL) {
        //   initOptions = PL.execInitPuzzles({ container: container }).initOptions;
        // }
        sceneURL = initOptions.useCompAssets ? `${sceneURL}.xz` : sceneURL;

        const preloader = this.createPreloader(container, initOptions, PE);

        const app = this.createAppInstance(
            container,
            initOptions,
            preloader,
            PE
        );

        if (initOptions.preloaderStartCb) initOptions.preloaderStartCb();
        app.loadScene(
            sceneURL,
            () => {
                // 缩放逻辑
                const camearPos = this.app.camera.position;
                const distance = camearPos.distanceTo(this.app.scene.position)                
                const fov = this.app.camera.fov * Math.PI / 180;
                const allH = 2 * distance * Math.tan(fov / 2);

                const box = new v3d.Box3().setFromObject(this.app.scene);
                const boxH = box.max.y - box.min.y;

                const maxH = allH * (initOptions.scale || 0.5)
                console.log('height', initOptions.scale, boxH, maxH)
                if (boxH > maxH) {
                    // 修改fov
                    const scaleFactor = boxH / maxH
                    console.log('scaleFactor', scaleFactor)
                    this.app.camera.fov = 2 * Math.atan(Math.tan(fov / 2) * scaleFactor) * 180 / Math.PI
                    this.app.camera.updateProjectionMatrix()
                    console.log('camera', this.app.camera.fov)
                }

                // window.camera = this.app.camera;
                // window.scene = this.app.scene;
                if (callback) {
                    callback();
                }
                app.enableControls();
                app.run();
                this.bindEventListener(app);
                // if (PE) PE.updateAppInstance(app);
                // if (PL) PL.init(app, initOptions);

                this.runCode(app, PL);
            },
            null,
            () => {
                console.log(`Can't load the scene ${sceneURL}`);
            }
        );
        return { app, PL };
    }

    createPreloader() {
        let preloader = new v3d.Preloader();
        preloader.onUpdate = p => {
            // console.log('preloader', p);
            this.dispatchEvent({ type: "loading", data: p });
        };
        preloader.onFinish = () => {
            this.dispatchEvent({ type: "loaded" });
        };
        return preloader;
    }

    createAppInstance(container, initOptions, preloader, PE) {
        const ctxSettings = {
            alpha: true,
            antialias: true,
            depth: true,
            premultipliedAlpha: true,
            preserveDrawingBuffer: false,
            stencil: true
        };
        if (initOptions.useBkgTransp) ctxSettings.alpha = true;
        if (initOptions.preserveDrawBuf)
            ctxSettings.preserveDrawingBuffer = true;

        console.log("createAppInstance", container, ctxSettings, preloader);
        const app = new v3d.App(container, ctxSettings, preloader);
        if (initOptions.useBkgTransp) {
            app.clearBkgOnLoad = true;
            if (app.renderer) {
                app.renderer.setClearColor(0x000000, 0);
            }
        }

        // namespace for communicating with code generated by Puzzles
        app.ExternalInterface = {};
        this.prepareExternalInterface(app);
        if (PE) PE.viewportUseAppInstance(app);

        return app;
    }

    prepareExternalInterface() {
        console.log("prepareExternalInterface");
    }

    runCode(app, puzzles) {
        console.log("runCode", app, puzzles);
        // add your code here, e.g. console.log('Hello, World!');
    }

    changeVis = (objSelector, bool, container = this.app.scene) => {
        const change = (k, vis) => {
            let obj = this.getObjectByName(k, container);
            if (!obj) {
                return;
            }
            obj.disableChildRendering = !vis;
            obj.visible = vis;
        };
        if (Array.isArray(objSelector)) {
            for (let i = 0; i < objSelector.length; i++) {
                let selector = objSelector[i];
                change(selector, bool);
            }
        } else {
            change(objSelector, bool);
        }
    };

    changeChildVis = (objSelector, bool, container) => {
        let obj = this.getObjectByName(objSelector, container);
        if (!obj) {
            return;
        }
        obj.children.forEach(child => {
            child.disableChildRendering = !bool;
            child.visible = bool;
        });
    };

    getObjectByName = (objName, container) => {
        let objFound;
        let runTime = this._pGlob !== undefined;
        objFound = runTime ? this._pGlob.objCache[objName] : null;

        if (objFound && objFound.name === objName) return objFound;
        if (container) {
            container.traverse(obj => {
                if (
                    !objFound &&
                    this.notIgnoredObj(obj) &&
                    obj.name === objName
                ) {
                    objFound = obj;
                    if (runTime) {
                        this._pGlob.objCache[objName] = objFound;
                    }
                }
            });
        } else {
            if (this.app.scene) {
                this.app.scene.traverse(obj => {
                    if (
                        !objFound &&
                        this.notIgnoredObj(obj) &&
                        obj.name === objName
                    ) {
                        objFound = obj;
                        if (runTime) {
                            this._pGlob.objCache[objName] = objFound;
                        }
                    }
                });
            }
        }

        return objFound;
    };

    notIgnoredObj = obj => {
        return (
            obj.type !== "AmbientLight" &&
            obj.name !== "" &&
            !(obj.isMesh && obj.isMaterialGeneratedMesh) &&
            !obj.isAuxClippingMesh
        );
    };

    matMap = new Map();

    assignMat(objSelector, matName) {
        // console.log('assignMat', objSelector, matName);
        let objNames = this.retrieveObjectNames(objSelector);
        if (!matName) {
            return;
        }
        let mat = this.matMap.get(matName);
        if (!mat) {
            mat = v3d.SceneUtils.getMaterialByName(this.app, matName);
        }
        if (!mat) {
            return;
        }
        // console.log('assignMat', objSelector, 'found');
        for (let i = 0; i < objNames.length; i++) {
            let objName = objNames[i];
            if (!objName) continue;
            let obj = this.getObjectByName(objName);
            if (obj) {
                let firstSubmesh = obj.resolveMultiMaterial()[0];
                this.matMap.set(
                    firstSubmesh.material.name,
                    firstSubmesh.material
                );
                firstSubmesh.material = mat;
            }
        }
    }

    retrieveObjectNames = objNames => {
        let acc = [];
        this.retrieveObjectNamesAcc(objNames, acc);
        return acc.filter(function(name) {
            return name;
        });
    };

    retrieveObjectNamesAcc = (currObjNames, acc) => {
        if (typeof currObjNames == "string") {
            acc.push(currObjNames);
        } else if (Array.isArray(currObjNames) && currObjNames[0] === "GROUP") {
            let newObj = this.getObjectNamesByGroupName(currObjNames[1]);
            for (let i = 0; i < newObj.length; i++) acc.push(newObj[i]);
        } else if (
            Array.isArray(currObjNames) &&
            currObjNames[0] === "ALL_OBJECTS"
        ) {
            let newObj = this.getAllObjectNames();
            for (let i = 0; i < newObj.length; i++) acc.push(newObj[i]);
        } else if (Array.isArray(currObjNames)) {
            for (let i = 0; i < currObjNames.length; i++)
                this.retrieveObjectNamesAcc(currObjNames[i], acc);
        }
    };

    getObjectNamesByGroupName = targetGroupName => {
        let objNameList = [];
        this.app.scene.traverse(obj => {
            if (this.notIgnoredObj(obj)) {
                let groupNames = obj.groupNames;
                if (!groupNames) return;
                for (let i = 0; i < groupNames.length; i++) {
                    let groupName = groupNames[i];
                    if (groupName === targetGroupName) {
                        objNameList.push(obj.name);
                    }
                }
            }
        });
        return objNameList;
    };

    getAllObjectNames = () => {
        let objNameList = [];
        this.app.scene.traverse(obj => {
            if (this.notIgnoredObj(obj)) objNameList.push(obj.name);
        });
        return objNameList;
    };

    bindEventListener = app => {
        const elem = app.renderer.domElement;
        elem.addEventListener("click", this._onClick);
    };

    unBindEventListener = app => {
        const elem = app.renderer.domElement;
        elem.removeEventListener("click", this._onClick);
    };

    _onClick = e => {
        const point = this.getPoint(e);
        this.getIntersectsAndDispatch(point, "click");
    };

    getIntersectsAndDispatch = (point, eventName) => {
        const intersects = this.getIntersects(point);
        const names = intersects.map(obj => obj.object.name);
        this.dispatchEvent({
            type: eventName,
            data: names
        });
    };

    getIntersects(point) {
        this.mouse.x = (point.x / this.container.offsetWidth) * 2 - 1;
        this.mouse.y = -(point.y / this.container.offsetHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.app.getCamera());
        return this.raycaster.intersectObject(this.app.scene, true);
    }

    getPoint(event) {
        if (event instanceof TouchEvent) {
            const { clientX, clientY } = event.touches[0];
            return { x: clientX, y: clientY };
        } else {
            const { offsetX, offsetY } = event;
            return { x: offsetX, y: offsetY };
        }
    }

    brightnessContrast(brightness, contrast) {
        this.app &&
            this.app.enablePostprocessing([
                {
                    type: "brightnessContrast",
                    brightness: brightness,
                    contrast: contrast
                }
            ]);
    }

    setScreenScale(factor) {
        if (!this.app.useHiDPIRenderPass)
            this.app.renderer.setPixelRatio(factor);

        if (this.app.postprocessing)
            this.app.postprocessing.composer.setPixelRatio(factor);

        // to update possible post-processing passes
        this.app.onResize();
    }
}
